import { render } from "./OverDetailsModal.vue?vue&type=template&id=768b0b79&scoped=true"
import script from "./OverDetailsModal.vue?vue&type=script&lang=js"
export * from "./OverDetailsModal.vue?vue&type=script&lang=js"

import "./OverDetailsModal.vue?vue&type=style&index=0&id=768b0b79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768b0b79"]])

export default __exports__